interface GenericPreviewProps {
  url: string;
  name: string;
}

export function GenericPreview({ url, name }: GenericPreviewProps) {
  return (
    <div className="flex flex-col items-center gap-4 text-center">
      <svg className="h-16 w-16 text-gray-600" viewBox="0 0 48 48" fill="none">
        <path d="M12 4a4 4 0 00-4 4v32a4 4 0 004 4h24a4 4 0 004-4V16L28 4H12z" stroke="currentColor" strokeWidth="2" />
        <path d="M28 4v12h12" stroke="currentColor" strokeWidth="2" />
      </svg>
      <p className="text-gray-400 text-sm">{name}</p>
      <p className="text-gray-500 text-xs">Preview not available for this file type</p>
      <a
        href={url}
        download={name}
        className="inline-flex items-center gap-2 rounded-lg bg-brand-600 px-4 py-2 text-sm font-medium text-white hover:bg-brand-500 transition-colors"
      >
        <svg className="h-4 w-4" viewBox="0 0 16 16" fill="currentColor">
          <path d="M8 12l-4-4h2.5V4h3v4H12L8 12z" />
          <path d="M4 14h8v1H4v-1z" />
        </svg>
        Download
      </a>
    </div>
  );
}
